import { api, unwrap } from '@saas-kit/lib';

import type { QmsBranding, QmsBrandingLogo, QmsBrandingUpdate } from './types';

export async function fetchBranding(): Promise<QmsBranding> {
  return unwrap<QmsBranding>(api.get('/qms/branding'));
}

export async function updateBranding(
  input: QmsBrandingUpdate,
): Promise<QmsBranding> {
  return unwrap<QmsBranding>(api.put('/qms/branding', input));
}

/** Upload a logo image; returns the file id to attach via updateBranding.
 *  No explicit Content-Type — the browser sets `multipart/form-data`
 *  with the boundary the server needs to parse the upload. */
export async function uploadBrandingLogo(
  file: File,
): Promise<QmsBrandingLogo> {
  const body = new FormData();
  body.append('uploaded_file', file);
  return unwrap<QmsBrandingLogo>(api.post('/qms/branding/logo', body));
}
